import shajs from 'sha.js';
export default function hash(input) {
    return shajs('sha256').update(input).digest('hex');
}
//# sourceMappingURL=hash.js.map